export enum Paths {
  authentication = 'authentication',
  application = 'application',
  demo = 'demo',
  login = 'login',
  forgotPassword = 'forgot-password',
  resetPassword = 'reset-password',
  form = 'form',
  table = 'table',
  serverTable = 'server-table',
  button = 'button',
  card = 'card',
  dialog = 'dialog',
  input = 'input',
  select = 'select',
  radioCheckbox = 'radio-checkbox',
  dashboard = 'dashboard',

  // Tracking
  tracking = 'tracking',
  advanceTracking = 'advance-tracking',

  //reports
  reports = 'reports',
  routeReports = 'route-reports',
  eventReports = 'event-reports',
  tripsReports = 'trips-reports',
  stopsReports = 'stops-reports',
  summaryReports = 'summary-reports',
  geofenceReports = 'geofence-reports',
  poiReports = 'poi-reports',

  //POI
  poi = 'poi',
  poiDetails = 'poi-details',
  addPoiDetails = 'add-poi-details',
  editPoiDetails = 'edit-poi-details',
  poiVehicles = 'poi-vehicles',

  // geofence
  geofence = 'geofence',

  // geofence overview inside geofence
  geofenceOverview = 'geofence-overview',
  addGeofenceOverview = 'add-geofence-overview',
  editGeofenceOverview = 'edit-geofence-overview',
  geofenceVehicle = 'geofence-vehicle',


  //temperature
  temperature = 'temperature',

  //temperature calibration inside temperature
  temperatureCalibration = 'temperature-calibration',
  addTemperatureCalibration = 'add-temperature-calibration',
  editTemperatureCalibration = 'edit-temperature-calibration',

  temperatureUnit = 'temperature-unit',
  addTemperatureUnit = 'add-temperature-unit',
  editTemperatureUnit = 'edit-temperature-unit',

  //Tyre
  tyre = 'tyre',

  //Tyre List inside tyre 
  tyreList = 'tyre-list',
  addTyre = 'add-tyre',
  editTyre = 'edit-tyre',

  // Tour
  tour = 'tour',

  // Tour Planning inside Tour
  tourPlanning = 'tour-planning',
  addTourPlanning = 'add-tour-planning',
  editTourPlanning = 'edit-tour-planning',

  // Tour Allocation inside Tour
  tourAllocation = 'tour-allocation',
  addTourAllocation = 'add-tour-allocation',
  editTourAllocation = 'edit-tour-allocation',


  //Alert Menu Start
  alert = 'alert',

  //alert group overview and add-edit alert inside alert module
  vehicleAlert = 'vehicle-alert',
  alertGroupOverview = 'alert-group-overview',
  addAlertGroup = 'add-alert-group',
  editAlertGroup = 'edit-alert-group',

  alertSpecification = 'alert-specification',
  addAlertSpecification = 'add-alert-specification',
  editAlertSpecification = 'edit-alert-specification',

  employeesByEmployeeGroup = 'employees-by-employee-group',
  //Alert Menu End

  //Licensing Module Start
  licensing = 'licensing',

  // user license inside Licensing
  userLicense = 'user-detail-license',
  addUserLicense = 'add-user-detail-license',
  editUserLicense = 'edit-user-detail-license',

  //company-details-license inside licensing  
  companyLicenseDetail = 'company-detail-license',
  addCompanyLicenseDetail = 'add-company-detail-license',
  editCompanyLicenseDetail = 'edit-company-detail-license',

  //vehicle-details-license inside license
  vehicleLicense = 'vehicle-license',
  addVehicleLicense = 'add-vehicle-license',
  editVehicleLicense = 'edit-vehicle-license',

  //Licensing Module End

  //maintenance Module Start
  maintenance = 'maintenance',

  //expense inside maintenance
  expense = 'expense',
  addExpense = 'add-expense',
  editExpense = 'edit-expense',
  expenseHistory = 'expense-history',

  //reminder inside maintenance
  reminder = 'reminder',
  addReminder = 'add-reminder',
  editReminder = 'edit-reminder',

  //maintenance Module End

  //Advance
  advance = 'advance',

  //route-path inside advance module
  routePath = 'route-path',
  addRoutePath = 'add-route-path',
  editRoutePath = 'edit-route-path',

  //route-path-allocation-group inside advance module
  routePathAllocationGroup = 'route-path-allocation-group',
  addRoutePathAllocationGroup = 'add-route-path-allocation-group',
  editRoutePathAllocationGroup = 'edit-route-path-allocation-group',

  //vehicle-group inside advance
  vehicleGroup = 'vehicle-group',
  addVehicleGroup = 'add-vehicle-group',
  editVehicleGroup = 'edit-vehicle-group',

  //employee-group inside advance
  employeeGroup = 'employee-group',
  addEmployeeGroup = 'add-employee-group',
  editEmployeeGroup = 'edit-employee-group',

  //App Config Menu
  appConfig = 'app-config',

  //company inside app-config
  company = 'company',
  addEditCompany = 'add-edit-company',
  companyMap = 'company-map',
  addEditCompanyMap = 'add-edit-company-map',

  //branch-details inside app-config
  branch = 'branch',
  addEditBranch = 'add-edit-branch',

  //vehicle-details inside app-config
  vehicle = 'vehicle',
  addVehicle = 'add-vehicle',
  updateVehicle = 'update-vehicle',
  vehicleDocument = 'vehicle-document',
  addVehicleDocument = 'add-vehicle-document',
  updateVehicleDocument = 'update-vehicle-document',

  //employee-details inside app-config
  employee = 'employee',
  addEmployee = 'add-employee',
  updateEmployee = 'update-employee',

  //gps device
  gpsDevice = 'gps-device',
  addGpsDevice = 'add-gps-device',
  updateGpsDevice = 'update-gps-device',

  //master data inside app-config
  masterData = 'master-data',

  //company rule inside app-config
  companyRule = 'company-rule',
  addCompanyRule = 'add-company-rule',
  editCompanyRule = 'edit-company-rule',


  //empty remove inside app-config
  emptyRemove = 'empty-remove',
  addEmptyRemove = 'add-empty-remove',

  //sms-allocation inside app-config
  smsAllocation = 'sms-allocation',
  addSmsAllocation = 'add-sms-allocation',
  updateSmsAllocation = 'update-sms-allocation',

  //customize tool tip inside app-config
  customizeToolTip = 'customize-tool-tip',
  addCustomizeToolTip = 'add-customize-tool-tip',
  updateCustomizeToolTip = 'update-customize-tool-tip',

  // add-device inside app-config
  device = 'device',
  addDevice = 'add-device',
  updateDevice = 'update-device',

  //User Rights
  userRights = 'user-rights',
  user = 'user',
  addUser = "add-user",
  editUser = "edit-user",
  userGroupList = "user-group-list",
  addUserGroup = "add-user-group",
  editUserGroup = "edit-user-group",

  //master
  master = 'master',
  applicationMainMenu = 'application-main-menu',
  addApplicationMainMenu = 'add-application-main-menu',
  editApplicationMainMenu = 'edit-application-main-menu',
  applicationSubMenu = 'application-sub-menu',
  addApplicationSubMenu = 'add-application-sub-menu',
  editApplicationSubMenu = 'edit-application-sub-menu',
  applicationModule = 'application-module',
  addApplicationModule = 'add-application-module',
  editApplicationModule = 'edit-application-module',
  userType = 'user-type',
  addUserType = 'add-user-type',
  editUserType = 'edit-user-type',
  employeeDesignation = 'employee-designation',
  addEmployeeDesignation = 'add-employee-designation',
  editEmployeeDesignation = 'edit-employee-designation',
  language = 'language',
  addLanguage = 'add-language',
  editLanguage = 'edit-language',
  country = 'country',
  addCountry = 'add-country',
  editCountry = 'edit-country',
  state = 'state',
  addState = 'add-state',
  editState = 'edit-state',
  city = 'city',
  addCity = 'add-city',
  editCity = 'edit-city',
  companyDetailAlert = 'company-detail-alert',
  addCompanyDetailAlert = 'add-company-detail-alert',
  editCompanyDetailAlert = 'edit-company-detail-alert',
  tariffPlanOverview = 'tariff-plan-overview',
  addTariffPlan = 'add-tariff-plan-overview',
  editTariffPlan = 'edit-tariff-plan-overview',
  simCardOverview = 'sim-card-overview',
  addSimCardOverview = 'add-Sim-Card-Overview',
  editSimCardOverview = 'edit-Sim-Card-Overview',
  storageDays = 'storage-days',
  addStorageDays = 'add-storage-days',
  editStorageDays = 'edit-storage-days',
  map = 'map',
  addMap = 'add-map',
  editMap = 'edit-map',
  documentType = 'document-type',
  addDocumentType = 'add-document-type',
  editDocumentType = 'edit-document-type',
  fuelType = 'fuel-type',
  addFuelType = 'add-fuel-type',
  editFuelType = 'edit-fuel-type',
  poiType = 'poi-type',
  fuelStation = 'fuel-station',
  addFuelStation = 'add-fuel-station',
  editFuelStation = 'edit-fuel-station',
  expenseType = 'expense-type',
  maintenanceType = 'maintenance-type',
  addMaintenanceType = 'add-maintenance-type',
  editMaintenanceType = 'edit-maintenance-type',
  vehicleType = 'vehicle-type',
  addVehicleType = 'add-vehicle-type',
  editVehicleType = 'edit-vehicle-type',
  vehicleCompany = 'vehicle-company',
  addVehicleCompany = 'add-vehicle-company',
  editVehicleCompany = 'edit-vehicle-company',
  vehicleModel = 'vehicle-model',
  addVehicleModel = 'add-vehicle-model',
  editVehicleModel = 'edit-vehicle-model',

  // tyre-brand inside master
  tyreBrand = 'tyre-brand',
  addTyreBrand = 'add-tyre-brand',
  editTyreBrand = 'edit-tyre-brand',
  tyreModel = 'tyre-model',
  addTyreModel = 'add-tyre-model',
  editTyreModel = 'edit-tyre-model',

  // device-brand inside master
  deviceBrand = "device-brand",
  addDeviceBrand = "add-device-brand",
  editDeviceBrand = "edit-device-brand",
  deviceModel = 'device-model',
  addDeviceModel = 'add-device-model',
  editDeviceModel = 'edit-device-model',
  deviceModelPortSpecification = 'device-model-port-specification',
  addDeviceModelPortSpecification = 'add-device-model-port-specification',
  editDeviceModelPortSpecification = 'edit-device-model-port-specification',

  deviceModelPortAllocation = 'device-model-port-allocation',
  addDeviceModelPortAllocation = 'add-device-model-port-allocation',
  editDeviceModelPortAllocation = 'edit-device-model-port-allocation',
  licenseToDrive = 'license-to-drive',
  addLicenseToDrive = 'add-license-to-drive',
  editLicenseToDrive = 'edit-license-to-drive',
  timeZone = 'timezone',
  addTimeZone = 'add-timezone',
  editTimeZone = 'edit-timezone',

  //custom tool tip header inside master
  toolTipHeader = 'custom-tool-tip-header',
  addToolTipHeader = 'add-custom-tool-tip-header',
  editToolTipHeader = 'edit-custom-tool-tip-header',

  toolTipOption = 'custom-tool-tip-option',
  addToolTipOption = 'add-custom-tool-tip-option',
  editToolTipOption = 'edit-custom-tool-tip-option',

  //fuel
  fuel = 'fuel',
  fuelCalibration = 'fuel-calibration',
  addFuelCalibration = 'add-fuel-calibration',
  updateFuelCalibration = 'update-fuel-calibration'
}
